import { render } from "./CourseExams.vue?vue&type=template&id=0a0bf4d1&ts=true"
import script from "./CourseExams.vue?vue&type=script&lang=ts"
export * from "./CourseExams.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__